import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';

import './twoPage3.scss';

function TwoPage3(props) {
  const {setCurrentPage, currentFooter} = props;
  console.log('currentFooter: ', currentFooter);

  const [isMob, setIsMob] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 1024) {
        setIsMob(false);
      } else {
        setIsMob(true);
      }
      const resizeThrottler = () => {
        if (window.innerWidth < 1024) {
          setIsMob(true);
        } else {
          setIsMob(false);
        }
      };

      window.addEventListener('resize', resizeThrottler, false);
    }

  

  }, []);

  return (
    <>
      <div className="growth-page growth-page--3">
        <div className="growth-page__row">
          <h1 className="growth-page__title _title _growth-anim">
            От&nbsp;нового финансового директора до&nbsp;нового фирменного знака
          </h1>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--1">
              <use href="/img/icons/icons.svg#_tl-bg-6"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--1">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Февраль</span>
            <span className="growth-page__year">2014</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">Новый финансовый директор</h2>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--2">
              <use href="/img/icons/icons.svg#_tl-bg-4"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--2">
          <div className="growth-page__col">
          {!isMob && 
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-3-1.png"
                  srcSet="img/two/growth-page-3-1.png 1x, img/two/growth-page-3-1@2x.png 2x"
                  alt="img"
                  className='_growth-anim'
                />
              </div>
              <p className="growth-page__caption _growth-anim _growth-anim--fade">Владимир Правдивый</p>
            </div>
          }
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              К&nbsp;работе приступил новый финансовый директор&nbsp;&mdash; Владимир Правдивый.
            </p>
            <p className="growth-page__text _text _growth-anim">
              На&nbsp;собеседовании с&nbsp;Йонасом и&nbsp;Филипом Владимир заявляет, что хочет стать
              гендиректором компании. Основатели классифайда его поддержали. Через год Правдивый
              станет исполнительным директором Авито, позже&nbsp;&mdash; гендиректором.
            </p>
            {isMob && 
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-3-1.png"
                  srcSet="img/two/growth-page-3-1.png 1x, img/two/growth-page-3-1@2x.png 2x"
                  alt="img"
                  className='_growth-anim'
                />
              </div>
              <p className="growth-page__caption _growth-anim _growth-anim--fade">Владимир Правдивый</p>
            </div>
          }
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                Авито переезжает в&nbsp;бизнес-центр рядом с&nbsp;метро &laquo;Белорусская&raquo;.
              </p>
            </div>
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-3-2.png"
                  srcSet="img/two/growth-page-3-2.png 1x, img/two/growth-page-3-2@2x.png 2x"
                  alt="img"
                  className="_growth-anim"
                />
              </div>
              <p className="growth-page__caption _growth-anim">
                &laquo;Авито&raquo; и&nbsp;ГК&nbsp;Korbitec запустили сайт объявлений о&nbsp;продаже
                и&nbsp;аренде недвижимости Domofond.ru. Туда дублировались объявления, размещенные
                агентами в&nbsp;&laquo;Авито Недвижимости&raquo;. Целью проекта стало собрать
                крупнейшую базу объявлений от&nbsp;профессиональных риэлторов.
              </p>
            </div>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--3">
              <use href="/img/icons/icons.svg#_tl-bg-7"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--3">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Март</span>
            <span className="growth-page__year">2014</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">Всероссийский рейтинг автодилеров</h2>
        </div>
        <div className="growth-page__row growth-page__row--4">
          <div className="growth-page__col"></div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              К&nbsp;&laquo;Авито Авто&raquo; подключаются официальные автодилеры. Компания
              выпускает первый всероссийский рейтинг автодилеров.
            </p>
            <p className="growth-page__text _text _growth-anim">
              Тогда на&nbsp;Авито работали 3348 активных дилеров, продаваших легковые авто,
              мотоциклы, грузовики, спецтехнику, запчасти&nbsp;&mdash; как новые, так
              и&nbsp;подержанные. Более 1000 из&nbsp;них&nbsp;&mdash; в&nbsp;Москве, более
              500&nbsp;&mdash; в&nbsp;Санкт-Петербурге. В&nbsp;2014 году в&nbsp;рейтинге было только
              4&nbsp;участника. Для сравнения: в&nbsp;совместном рейтинге &laquo;Авито Авто&raquo;
              и&nbsp;&laquo;Автостата&raquo; 2022 года был 51&nbsp;победитель
              в&nbsp;7&nbsp;номинациях при более 600&nbsp;заявках.
            </p>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--4">
              <use href="/img/icons/icons.svg#_tl-bg-4"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--5">
          <div className="growth-page__wrap-img">
            <div className="growth-page__img _growth-anim">
              <img
                src="img/two/growth-page-3-3.png"
                srcSet="img/two/growth-page-3-3.png 1x, img/two/growth-page-3-3@2x.png 2x"
                alt="img"
                className='_growth-anim'
              />
            </div>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--6">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Сентябрь</span>
            <span className="growth-page__year">2014</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">Новый фирменный знак</h2>
        </div>
        <div className="growth-page__row growth-page__row--7">
          <div className="growth-page__col">
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                В&nbsp;этом&nbsp;же году команда продаж Авито открывает офис в&nbsp;Санкт-Петербурге
                на&nbsp;Малой Охте.
              </p>
            </div>
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                В&nbsp;продвижении компания делает ставку на&nbsp;человеческие истории
                и&nbsp;важность общения
              </p>
            </div>
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              Авито готовит ребрендинг&nbsp;&mdash; новый фирменный знак Uni из&nbsp;четырех
              разноцветных шариков.
            </p>
            <div className="color-list growth-page__color-list _growth-anim">
              <div className="color-list__item"> — «Авто»</div>
              <div className="color-list__item"> — «Работа»</div>
              <div className="color-list__item"> — «Недвижимость»</div>
              <div className="color-list__item"> — «Услуги»</div>
            </div>
            <p className="growth-page__text _text _growth-anim">
              Вертикаль &laquo;Товаров&raquo;&nbsp;&mdash; белый фон.
            </p>
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-3-4.png"
                  srcSet="img/two/growth-page-3-4.png 1x, img/two/growth-page-3-4@2x.png 2x"
                  alt="img"
                  className='_growth-anim'
                />
              </div>
              <p className="growth-page__caption _growth-anim _growth-anim--fade">Элементы фирменного стиля 2014 года</p>
            </div>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--5">
              <use href="/img/icons/icons.svg#_tl-bg-20"></use>
            </svg>
            <svg className="_gr-bg _gr-bg--6">
              <use href="/img/icons/icons.svg#_tl-bg-2"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--8">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Октябрь</span>
            <span className="growth-page__year">2014</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            Фокус&nbsp;&mdash; на&nbsp;развитие бизнеса клиентов
          </h2>
        </div>
        <div className="growth-page__row growth-page__row--9">
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              На&nbsp;рекламное продвижение товаров приходилась уже половина выручки
              &laquo;Авито&raquo;. И&nbsp;компания ввела сервис &laquo;Авито Промо&raquo;: продавцы
              могут выбирать целевую аудиторию своих рекламных кампаний по&nbsp;интересам, месту
              жительства и&nbsp;другим критериям.
            </p>
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              Для профи-пользователей тоже запустили новые опции. Например, PRO-кабинет
              с&nbsp;&laquo;Автозагрузкой&raquo;. Благодаря ей&nbsp;бизнес может создавать или
              редактировать сразу сотни объявлений. Достаточно обновить информацию в&nbsp;Excel-,
              XML- или CSV-файлах.
            </p>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--7">
              <use href="/img/icons/icons.svg#_tl-bg-2"></use>
            </svg>
            <svg className="_gr-bg _gr-bg--8">
              <use href="/img/icons/icons.svg#_tl-bg-8"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__footer _footer">
          <div className="growth-page__footer-col">
            <div className="growth-page__footer-date">
            2014
            </div>
          </div>
          <div
            className="growth-page__footer-col"
            onClick={() => setCurrentPage({ status: true, el: 4 })}>
            <div className="growth-page__footer-img">
              <img
                src={`img/two/growth-page-footer-4.png`}
                srcSet={`img/two/growth-page-footer-4.png 1x, img/two/growth-page-footer-4@2x.png 2x`}
                alt="img"
              />
            </div>
            <span className="growth-page__footer-year">
            2015
            </span>
            <h3 className="growth-page__footer-title">
            Участник площадки — вся страна
            </h3>
          </div>
          <div className="growth-page__footer-col">
            <span
              className="growth-page__footer-date"
              onClick={() => setCurrentPage({ status: true, el: 4 })}>
              Далее
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default TwoPage3;
